import BaseModel from "./base/baseModel";

export default class RascunhoModel extends BaseModel {
    id?: string = null;
    entidade?: string = null;
    data?: string = null;
    nome?: string = null;
}
